export default __webpack_public_path__ + "static/media/ISSO CLASS-4 EXAM PATTERN 2026-27.04c4372b.pdf";